import React from 'react';
import classnames from 'classnames';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';

import { AuthBox } from '../auth-box';
import { Notifications } from '../notifications';
import logo from '../../assets/leo.png';

const useStyles = makeStyles((theme) =>
  createStyles({
    appBar: {
      [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${240}px)`,
        marginLeft: 240,
      },
    },
    menuButton: {
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    title: {
      width: 50,
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    rightContent: {
      display: 'flex',
      marginLeft: 'auto',
      alignItems: 'center',
    },
    auth: {
      marginLeft: theme.spacing(2),
    },
    showTitle: {
      width: 50,
    },
    homebtn: {
      marginRight: theme.spacing(1),
    },
  })
);

type HeaderProps = {
  onMenuClick?: () => void;
  className?: string;
  showTitle?: boolean;
};

export const Header: React.FC<HeaderProps> = ({
  onMenuClick,
  className,
  showTitle,
}: HeaderProps) => {
  const classes = useStyles();
  return (
    <AppBar position="fixed" className={classnames(classes.appBar, className)}>
      <Toolbar>
        {showTitle ? (
          <IconButton
            color="inherit"
            edge="start"
            className={classes.homebtn}
            onClick={onMenuClick}
          >
            <HomeIcon />
          </IconButton>
        ) : (
          <IconButton
            color="inherit"
            edge="start"
            className={classes.menuButton}
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}
        <img src={logo} className={showTitle ? classes.showTitle : classes.title} alt="logo" />
        <div className={classes.rightContent}>
          <Notifications />
          <div className={classes.auth}>
            <AuthBox />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
